import { clsx } from "@/src/utils/clsx"

type PreHeadingElementProps = {
    text?: string
    className?: string
}

export default function PreHeadingElement({ text, className }: PreHeadingElementProps) {
    if (!text) return null
    return (
        <p className={clsx(className, "Trim_Mono_POC_Text_14_130_0_400_uppercase")}>
            {text}
        </p>
    )
}
